export enum RewardStatusEnum {
  GRANTED = 'granted',
  PENDING = 'pending',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  FAILED = 'failed',
  CLAIMED = 'claimed',
  UNCLAIMED = 'unclaimed',
  DELETED = 'deleted',
  EXPIRED = 'expired',
}
